import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from 'react';
import {Button, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {excelFileUploader} from "../../../../helpers/excel-uploader";
import {faFileExcel, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {TYPE_RETURN_SHIPMENT} from "../../../../enum/ExcelTemplateTypes";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {selectOrganizationTemplates} from "../../../../app/store/reducers/excel/excelReducer";
import {uploadReturnShipmentToExcelAsync} from "../../../../app/store/reducers/return-shipment/returnShipmentReducer";
import checkPermission from "../../../../enum/Permission/CheckPermission";
import toastPermission from "../../../../enum/Permission/ToastPermission";
import {PermissionEdiReturnShipmentDownloadExcel} from "../../../../enum/Permission/EdiPermission";

const UploadReturnShipmentToExcel = ({id, number, ...props}) => {
    const dispatch = useDispatch()

    const [returnShipmentTypeTemplates, setReturnShipmentTypeTemplates] = useState([]);
    const organizationTemplates = useSelector(selectOrganizationTemplates);
    const [loading, setLoading] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    useEffect(() => {
        const templates = organizationTemplates.filter(template => template.type === TYPE_RETURN_SHIPMENT) || [];
        setReturnShipmentTypeTemplates(templates);
    }, [organizationTemplates])

    const uploadReturnShipment = (uri) => {
        if(dispatch(checkPermission(PermissionEdiReturnShipmentDownloadExcel))) {
            setLoading(true);

            uploadReturnShipmentToExcelAsync({uri: uri, id: id})
                .then(loadedContent => {
                    excelFileUploader({
                        content: loadedContent,
                        fileName: t(lang, 'edi.return_shipment.excel.file.name', {number: number}),
                    })
                })
                .catch(error => console.log(error))
                .finally(() => setLoading(false))
        }
        else dispatch(toastPermission())
    }

    return (
        <>
            {returnShipmentTypeTemplates.length > 1
                ?
                <Dropdown {...props}>
                    <Dropdown.Toggle bsPrefix="toggle" variant="falcon-default" size="sm" disabled={loading}>
                        {loading
                            ? <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                            : <FontAwesomeIcon className="me-1" icon={faFileExcel}/>
                        }
                        <span className="d-none d-sm-inline-block">
                        {t(lang, 'edi.common.export_to_excel')}
                    </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='py-2'>
                        {returnShipmentTypeTemplates.map((template, index) => (
                            <Dropdown.Item key={index} onClick={() => uploadReturnShipment(template.uri)}>
                                {t(lang, 'main.common.file.upload.template_name.prefix', {template_name: t(lang, `common.excel.template.name.${template.name}`)})}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                :
                <Button {...props} variant="falcon-default" size="sm" onClick={() => {
                    const [defaultTemplate] = returnShipmentTypeTemplates;
                    uploadReturnShipment(defaultTemplate.uri);
                }}>
                    {loading
                        ? <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                        : <FontAwesomeIcon className="me-1" icon={faFileExcel}/>
                    }

                    <span className="d-none d-sm-inline-block">{t(lang, 'edi.common.export_to_excel')}</span>
                </Button>
            }
        </>
    );
};

export default UploadReturnShipmentToExcel;
